import React, { useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useAddBrand, useUpdate } from "./useBrandRepo";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";


// Define types for brand data
interface Brand {
  brandname: string;
  brandcode: string;
  brandrate: string;
  minvalue: string;
  orgunit: string;
  Orgunitid:string;
  BrandId:string,

}

interface formInteface {
   brandname:string,
    brandcode:string,
    brandrate:any,
    minvalue:any,
    orgUnit: number | any
 }

// Define props for the component
interface BrandModalContentProps {
  selectedBrand: Brand;
  setSelectedBrand: React.Dispatch<React.SetStateAction<Brand>>;
  handleClose: () => void;
}

const BrandModalContent: React.FC<BrandModalContentProps> = ({
  selectedBrand,
  setSelectedBrand,
  handleClose,
}) => {

   const[formdata,setformData] = useState<formInteface>({
    brandname:selectedBrand.brandname,
    brandcode:selectedBrand.brandcode,
    brandrate:selectedBrand.brandrate,
    minvalue:selectedBrand.minvalue,
    orgUnit:selectedBrand.Orgunitid,
   })

  const { data: orgUnitsData,isLoading,isSuccess } = useGetOrgUnitsData({ enable: true });  
  const formatedOrgData = Object.entries(orgUnitsData?.data ||{}).map(([id,label])=>({
    id:String(id),
    label: String(label)
  }))
  
  // console.log('formatedOrgData',formatedOrgData);


const {mutate:addBrnad} = useAddBrand();
const {mutate:updateBrand} = useUpdate()
 
const handleSubmit = (e: React.FormEvent) => {
  e.preventDefault();
  if(!selectedBrand.brandname){
    // console.log("Add Form :", formdata);

    const ReqBody = {
      BrandName:formdata.brandname,
      BrandCode:formdata.brandcode,
      BrandRate:Number(formdata.brandrate) ,
      MinValue:Number(formdata.minvalue),
      Orgunitid:Number(formdata.orgUnit),
    }
    addBrnad({ReqBody:ReqBody})
    
  }else if(selectedBrand.brandname){
    // console.log("Form Update:", formdata);
    // console.log('selectedBrandID--->',selectedBrand.BrandId);
    const ReqBody = {
      BrandName: formdata.brandname,
      BrandCode: formdata.brandcode,
      BrandRate: Number(formdata.brandrate),
      MinValue: Number(formdata.minvalue),
      Orgunitid: Number(formdata.orgUnit),
    }
    updateBrand({id:Number(selectedBrand.BrandId),ReqBody:ReqBody})
  }

  handleClose();
};

  // Function to handle input changes
  const handleInputChange = (key: keyof formInteface, value: string) => {
       setformData((prev:any)=>({
        ...prev,
         [key]:value 
       }))
  };


  return (
    <form onSubmit={handleSubmit}>
      {/* Org Unit Dropdown */}
       <ReusableDropdown
        options={(formatedOrgData) ||[]}
        // options={[]}
        value={formdata.orgUnit}

        onChange={(value: any)=>handleInputChange('orgUnit',value) }
        DropdownHeading="Org Unit"
       /> 
      {/* Brand Name */}
      <label style={{ fontWeight: "500", marginTop:4}}>Brand Name</label>
      <input
        required
        type="text"
        className="form-control"
        placeholder="Enter brand name"
        value={formdata.brandname}
        onChange={(e) => handleInputChange("brandname", e.target.value)}
        style={inputStyle}
      />

      {/* Brand Code */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Brand Code
      </label>
      <input
        required
        type="text"
        placeholder="Enter brand code"
        className="form-control"
        value={formdata.brandcode}
        onChange={(e) => handleInputChange("brandcode", e.target.value)}
        style={inputStyle}
      />

      {/* Brand Rate */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Brand Rate<span style={{color:'red'}} >*</span>
      </label>
      <input
        required
        type="text"
        placeholder="Enter brand rate"
        className="form-control"
        value={formdata.brandrate}
        onChange={(e) => handleInputChange("brandrate", e.target.value)}
        style={inputStyle}
      />

      {/* Min Value */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Min Value<span style={{color:'red'}} >*</span>
      </label>
      <input
        required
        type="text"
        placeholder="Enter min value"
        className="form-control"
        value={formdata.minvalue}
        onChange={(e) => handleInputChange("minvalue", e.target.value)}
        style={inputStyle}
      />
      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn style={{ backgroundColor: "#43B9B2", color: "white" }} /* type={selectedBrand.brandname? 'submit':'button'}  */type="submit">
          {selectedBrand.brandname ? "Update Brand" : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

// Common input styles
const inputStyle: React.CSSProperties = {
  border: "2px solid #EDEDED",
  borderRadius: "4px",
  padding: "13px",
  fontSize: "14px",
  width: "100%",
};

export default BrandModalContent;
